export default __webpack_public_path__ + "static/media/supervision-en.afbbd03d.png";